<template>
	<div role="progressbar" class="mdc-linear-progress mdc-linear-progress--indeterminate" :aria-label="label" aria-valuemin="0" aria-valuemax="1" ref="lineRef">
		<div class="mdc-linear-progress__buffer">
			<div class="mdc-linear-progress__buffer-bar"></div>
			<div class="mdc-linear-progress__buffer-dots"></div>
		</div>
		<div class="mdc-linear-progress__bar mdc-linear-progress__primary-bar">
			<span class="mdc-linear-progress__bar-inner"></span>
		</div>
		<div class="mdc-linear-progress__bar mdc-linear-progress__secondary-bar">
			<span class="mdc-linear-progress__bar-inner"></span>
		</div>
	</div>
</template>

<script setup>
import { MDCLinearProgress } from '@material/linear-progress'
import { onMounted, ref, watch } from 'vue'

const props = defineProps({
	label: String,
})

let bar = null
const lineRef = ref()
onMounted(() => {
	bar = new MDCLinearProgress(lineRef.value)
})

</script>

<style scoped lang="scss">
@use "@material/linear-progress";

@include linear-progress.core-styles;
</style>
